import { render, staticRenderFns } from "./complicativeType.vue?vue&type=template&id=5acf574c&scoped=true"
import script from "./complicativeType.vue?vue&type=script&lang=js"
export * from "./complicativeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acf574c",
  null
  
)

export default component.exports